























import Vue from 'vue'
import Component from 'vue-class-component';
import {Prop} from 'vue-property-decorator';
import Department from '@/modules/reservation/model/Department';
import {Colors, notify} from '@/modules/core/notification';
import {AxiosError} from 'axios';

/**
 * Dialogo mostrado al usuario para que confirme la eliminación de un
 * departamento
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component
export default class ConfirmDepartmentDelete extends Vue {
    /**
     * Controla la visibilidad del dialogo
     */
    @Prop({type: Boolean, default: false})
    public value: boolean

    /**
     * Departamento que el usuario desea eliminar
     */
    @Prop({type: Department, default: () => new Department()})
    public department: Department

    public deleting = false

    /**
     * Solicita a la aplicación la eliminación del departamento
     */
    public async deleteDepartment () {
        this.deleting = true
        await this.$store.dispatch('reservation/deleteDepartment', this.department.id)

        this.deleting = false
        this.$emit('input', false)
        this.$emit('deleted', true)

        notify(`El departamento ${this.department.name} de ${this.department.type.name} se ha eliminado correctamente`)
    }

    /**
     * Captura cualquier error lanzado durante el proceso de eliminación del departamento.
     * Cierra el modal y notifica al usuario con el mensaje de error.
     *
     * @param error
     */
    public errorCaptured (error: AxiosError | Error) {
        this.deleting = false
        this.$emit('input', false)

        notify(error.message, Colors.Error)
    }
}
